import { ReactNode } from "react";
import { Toaster } from "react-hot-toast";
import { toastMessage } from "../helpers/toast/toastMessage";

interface ToastProviderProps {
  children: ReactNode;
}

const ToastProvider = ({ children }: ToastProviderProps) => (
  <>
    <Toaster
      position="top-center"
      reverseOrder={false}
      containerStyle={{ maxWidth: "100vw", padding: "0 16px" }}
      toastOptions={{ style: { maxWidth: "calc(100vw - 32px)" } }}
    />
    {children}
  </>
);

export { ToastProvider, toastMessage };
